import { GridColumnVisibilityModel } from '@microservices/wiskey-react-table-component'

export const compareModels = (
  firstModel: GridColumnVisibilityModel,
  secondModel: GridColumnVisibilityModel
): GridColumnVisibilityModel => {
  const result: GridColumnVisibilityModel = {}
  const keys = new Set([...Object.keys(firstModel), ...Object.keys(secondModel)])

  keys.forEach(field => {
    if (firstModel[field] !== secondModel[field]) {
      result[field] = secondModel[field]
    }
  })

  return result
}
